"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShellBannerImageDark = exports.ShellBannerImage = exports.SocialYoutube = exports.SocialTwitter = exports.SocialLinkedIn = exports.SocialInstagram = exports.SocialFacebook = void 0;
const social_facebook_svg_1 = __importDefault(require("./icons/social-facebook.svg"));
exports.SocialFacebook = social_facebook_svg_1.default;
const social_instagram_svg_1 = __importDefault(require("./icons/social-instagram.svg"));
exports.SocialInstagram = social_instagram_svg_1.default;
const social_linkedin_svg_1 = __importDefault(require("./icons/social-linkedin.svg"));
exports.SocialLinkedIn = social_linkedin_svg_1.default;
const social_twitter_svg_1 = __importDefault(require("./icons/social-twitter.svg"));
exports.SocialTwitter = social_twitter_svg_1.default;
const social_youtube_svg_1 = __importDefault(require("./icons/social-youtube.svg"));
exports.SocialYoutube = social_youtube_svg_1.default;
const shell_banner_webp_1 = __importDefault(require("./images/shell-banner.webp"));
exports.ShellBannerImage = shell_banner_webp_1.default;
const shell_banner_dark_webp_1 = __importDefault(require("./images/shell-banner-dark.webp"));
exports.ShellBannerImageDark = shell_banner_dark_webp_1.default;
